import React from "react";

import styles from "./BackButton.module.css";
import backArrow from "../icons/back-arrow.svg";

const BackButton = ({ size, onClick, ...rest }) => {
  return (
    <button
      className={styles.goBack}
      onClick={onClick}
      {...rest}
      style={{
        "--icon-size": size || "1.2rem",
        ...rest?.style,
      }}
    >
      <img src={backArrow} alt="back" className={styles.goBackIcon} />
    </button>
  );
};

export default BackButton;
